<template>
  <div class="detailCont_warp">
    <TopBar :pageTitle="'热门活动'" />
    <div class="content_warp">
      <div class="head_cont">
        <div class="img">
          <img v-if="contentData.image" :src="contentData.image" alt="" />
          <img v-else src="@/assets/m/activity_img/m_img.png" alt="" />
        </div>
        <div class="right_cont">
          <div class="cont_info">
            <p class="title">{{ contentData.title }}</p>
            <p class="info">{{ contentData.desc }}</p>
            <p class="tips flex">
              <img src="@/assets/m/activity_img/icon1.png" alt="" />
              <span>活动形式：{{ contentData.way == 1 ? "线上" : "线下" }}</span>
            </p>
            <!-- <p class="btn" @click="orderState = true">立即报名</p> -->
          </div>
        </div>
      </div>
      <div class="nav_box">
        <div class="left_cont_info">
          <p class="text">活动内容</p>
          <div v-html="contentData.content"></div>
        </div>
      </div>
    </div>
    <div class="deep_box flex">
      <div class="text" @click="$router.push('/activity/signUp?id='+detailId)">立即报名</div>
    </div>
  </div>
</template>
<script>
// import { activityDetail ,activityRecommend,activityForm} from "@/API/api";
import TopBar from "@/m/common/topBar.vue";
export default {
  name: "active_box",
  components: {
    TopBar,
  },
  data() {
    return {
      detailId: "",
      contentData: {},
      orderState: false, // 预约
      yuyForm: {
        activity_id: "",
        source: "ksk主站",
        name: "",
        phone: "",
        remark: "",
      },
      recommedList: [],
      urlHead:'http',
    };
  },
  mounted() {
    let urlHttp = window.location.href
    this.urlHead = 'http'
    if(urlHttp.includes('https')){
       this.urlHead = 'https'
    }
    this.detailId = this.$route.query.id;
    if (this.detailId) {
      this.getDetail(this.detailId);
    }
    this.getList();
    
  },
  methods: {
    getDetail(id) {
      this.$axios
        .get(
          this.urlHead+`://newkskapi.kskstudy.com/om/v1/api/activity/detail?id=` +
            id
        )
        .then((res) => {

          res.data.content = res.data.content.replace(
            /<img/gi,
            '<img style="max-width:100%;height:auto;"'
          );
          this.contentData = res.data;
        });
    },
    getList() {
      this.$axios
        .get(this.urlHead+`://newkskapi.kskstudy.com/om/v1/api/activity/recommend`)
        .then((res) => {
          this.recommedList = res.data;
        });
    },

    submitBtn() {
      this.yuyForm.activity_id = this.detailId;
      if (this.yuyForm.phone.length < 11) {
        this.$message.error("请填写正确的手机号");
        return;
      }
      this.$axios
        .post(
          this.urlHead+`://newkskapi.kskstudy.com/om/v1/api/activity/activityForm`,
          this.yuyForm
        )
        .then((res) => {
          if (res.code == 1) {
            this.$message.success(res.msg);
          } else {
            this.$message.error(res.msg);
          }
          this.orderState = false;
        });
      // activityForm(this.yuyForm).then(res=>{
      //    if(res.code==1){
      //     this.$message.success(res.msg)
      //    }else{
      //     this.$message.error(res.msg)
      //    }
      //    this.orderState = false
      // })
    },
    // isMobile(value) {
    //   let phone = '^[1-9]{1}[0-9]{5,8}$'
    // 	return phone.test(value);                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      return /^(https?|ftp):\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i.test(value);
    // },
  },
};
</script>
<style scoped lang="scss">
.detailCont_warp {
  background: #f9f9f9;
  .content_warp {
   padding-bottom: 120px;
   margin-top: 10px;
    .head_cont {
      margin: 0 auto;
      padding: 50px 30px ;
       background: #fff;
      div.img {
        width: 690px;
        height: 392px;
        img {
          width: 100%;
          height: 100%;
          border-radius: 20px;
        }
      }
      .right_cont {
        margin-top: 24px;
        p.title {
            font-size: 34px;
            font-family: Microsoft YaHei-Regular, Microsoft YaHei;
            font-weight: 400;
            color: #333333;
        }
        p.info{
          font-size: 24px;
          color: #666;
          margin-top: 15px;
        }
        p.tips{
            margin-top: 24px;
            img{
                width: 30px;
                height: 30px;
            }
            span{
                margin-left: 10px;
                font-size: 20px;
                color: #999999;
            }
        }
      }
    }
    .nav_box{
        margin-top: 50px;
        .left_cont_info{
            p.text{
                 margin-left: 30px;
                 font-size: 30px;
                font-family: Microsoft YaHei-Regular, Microsoft YaHei;
                font-weight: 400;
                color: #666666;
            }
            div{
                padding: 0 30px;
                margin-top: 30px;
                background: #fff;
            }
        }
       
    }
  }
}
.deep_box{
  position: fixed;
  left: 0;
  bottom: 0;
  background: #fff;
  height: 120px;
  width: 100%;
 justify-content: center;
  .text{
    width: 600px;
    height: 80px;
    line-height: 80px;
    text-align: center;
    background: linear-gradient(270deg, #FF9211 0%, #FF6711 100%);
    border-radius: 5px;
    color: #fff;
    font-size: 32px;
  }
}
</style>
